<template>
  <b-row>
    <b-col
      lg="12"
      class-name="mb-1"
    >
      <b-card-text
        size="10"
        class-name="text-left"
      >
        {{ $t("api token") }}
      </b-card-text>
      <b-input-group>
        <b-input-group-prepend>
          <b-button
            variant="danger"
            @click="updateToken"
          >
            <b-spinner
              v-if="spin"
              small
            />
            <feather-icon
              v-else
              icon="RotateCcwIcon"
            />
          </b-button>
        </b-input-group-prepend>
        <b-form-input
          v-model="apiToken"
          disabled
        />
        <b-input-group-append>
          <b-button
            v-clipboard:copy="apiToken"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
            variant="outline-primary"
          >
            <feather-icon icon="CopyIcon" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BRow,
  BCol,
  BButton,
  BCardText,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'TokenInput',
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BRow,
    BCol,
    BButton,
    BCardText,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: Number,
    },
    token: {
      type: String,
    },
  },
  data() {
    return {
      spin: false,
      apiToken: '',
    }
  },
  created() {
    this.apiToken = this.token
  },
  methods: {
    updateToken() {
      this.$swal({
        title: this.$t('Are you sure?'),
        text: this.$t('Updating api token will disconnect the previous token'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Yes'),
        cancelButtonText: this.$t('No'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.spin = true
          this.$http.put(`accounts/${this.id}`, {
            token: this.token,
          }).then(response => {
            this.apiToken = response.api_token
            this.spin = false
          }).catch(() => {
            this.spin = false
          })
          this.$swal({
            icon: 'success',
            title: this.$t('api token updated'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    onCopy() {
      this.showSuccessNotification(this.$t('token copied'))
    },
    onError() {
      this.showErrorNotification(this.$t('Failed to copy token!'))
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
